// extracted by mini-css-extract-plugin
export default {"qrcodeContainer":"Qrcode_qrcodeContainer__NswV6","header":"Qrcode_header__adT5e"};